/**
 * Client-side helpers for products hidden from listings (gift card, gift packaging, etc.).
 */
(function () {
  window.theme = window.theme || {};

  const config = theme.productListingExclusions || {};
  const titlePhrases = (config.titlePhrases || [])
    .map((phrase) => String(phrase || '').trim().toLowerCase())
    .filter(Boolean);
  const productHandles = new Set(
    (config.productHandles || [])
      .map((handle) => String(handle || '').trim().toLowerCase())
      .filter(Boolean)
  );

  theme.isProductListingExcluded = function isProductListingExcluded({ title, handle } = {}) {
    const normalizedHandle = String(handle || '').trim().toLowerCase();
    if (normalizedHandle && productHandles.has(normalizedHandle)) return true;

    const normalizedTitle = String(title || '').trim().toLowerCase();
    if (!normalizedTitle || !titlePhrases.length) return false;

    return titlePhrases.some((phrase) => normalizedTitle.includes(phrase));
  };

  theme.filterProductListingHandles = function filterProductListingHandles(handles) {
    return (handles || []).filter((handle) => !theme.isProductListingExcluded({ handle }));
  };
})();
